var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,11c0,6.1,4.9,11,11,11s11-4.9,11-11c0-6.1-4.9-11-11-11S0,4.9,0,11z M12,16.4c0,0.5-0.5,1-1,1s-1-0.5-1-1 l0,0c0-0.5,0.5-1,1-1S12,15.9,12,16.4L12,16.4z M14.6,7.1c0.2,1.4-0.3,2.8-1.5,3.6c-0.7,0.5-1.2,1.3-1.2,2v0.3c0,0.5-0.5,1-1,1 s-1-0.5-1-1v-0.3c0-1.4,0.7-2.7,2-3.6c0.5-0.4,0.8-1,0.7-1.7c-0.1-0.7-0.7-1.2-1.3-1.3c-0.5-0.1-1,0-1.4,0.4 C9.5,6.8,9.3,7.3,9.3,7.8c0,0.5-0.5,1-1,1s-1-0.5-1-1c0-1.1,0.5-2.1,1.3-2.8s1.9-1,3-0.8C13.1,4.4,14.3,5.6,14.6,7.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownIcon);
export default __webpack_public_path__ + "static/media/unknown-icon.585b1277d71535f671788a285787279a.svg";
export { ForwardRef as ReactComponent };